import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleCallback = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          const user = await processSession(sessionId);
          // Clear the hash and redirect to home with user data
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/', { state: { user }, replace: true });
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/login', { state: { error: 'Authentication failed' }, replace: true });
        }
      } else {
        // No session_id found, redirect to home
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [location.hash, navigate, processSession]);

  return (
    <div className="bg-[#0B0F0E] min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#52ea88] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#9FBFB4]">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
